const DefaultEditorModeManager = require('./default');
const CompanyFactory = require('../../factory/company').instance;

function BrandTemplateEditorModeManager () {
  this.type = 'brand_template';

  this.hideList = [
    'header button[data-action="resize"]',
    'header > .tool-size'
  ];
}

BrandTemplateEditorModeManager.prototype = new DefaultEditorModeManager();

BrandTemplateEditorModeManager.prototype.enableUI = function () {
  DefaultEditorModeManager.prototype.enableUI.call(this);

  $('.tool-menu a[role="tab"][href="#tabAdmin"]').parent().hide();
  $('.tool-menu a[role="tab"][href="#tabLayouts"]').parent().hide();
};

BrandTemplateEditorModeManager.prototype.disableUI = function () {
  DefaultEditorModeManager.prototype.disableUI.call(this);

  $('.tool-menu a[role="tab"][href="#tabAdmin"]').parent().show();
  $('.tool-menu a[role="tab"][href="#tabLayouts"]').parent().show();
};

BrandTemplateEditorModeManager.prototype.afterUIEnable = function (data) {
  CompanyFactory.get(['templates', INKIVE.C.BOOK.encodedId]).then(function (template) {
    $('.tool-menu a[role="tab"][href="#tabLayouts"]').parent().show();
    $(window).trigger('resize');

    const isEmpty = $('#svgroot .main').find(':not(title)').length === 0;
    isEmpty && $('.tool-menu a[role="tab"][href="#tabLayouts"]').trigger('click');

    const WorkflowFactory = require('../../factory/workflow');
    WorkflowFactory.getJobs(template, 'brand_template').then((jobs) => {
      Array.isArray(jobs) && jobs[0] && jobs[0].state === 'submitted' && blockEditorFromEditing();
    });
  });
};

function blockEditorFromEditing () {
  const header = document.querySelector('header');

  INKIVE.C.EDITOR_BLOCKED = true;
  INKIVE.Tool.disableUI();
  header.classList.remove('disabled');
  header.querySelector('[data-value=project-name]').style.pointerEvents = 'none';
  header.querySelectorAll('button').forEach((button) => {
    ['exit', 'download', 'download-video'].includes(button.dataset.action) || button.classList.add('disabled');
  });

  localStorage.setItem('lock_elements', 'true');
  document.querySelector('#svgcontent').classList.add('global-locked');
}

module.exports = BrandTemplateEditorModeManager;
